module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', [_vm._v("VOL. 1 ")]), _vm._v(" "), _c('h2', {
    staticClass: "h1",
    attrs: {
      "id": "sigil_toc_id_1"
    }
  }, [_vm._v("CONTENTS")]), _vm._v(" "), _c('div', {
    staticClass: "center"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/Section0003#CHAPTER_I"
    }
  }, [_vm._v("CHAPTER I")]), _c('br', {
    staticClass: "calibre"
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/Text/Section0004#CHAPTER_II"
    }
  }, [_vm._v("CHAPTER II")]), _c('br', {
    staticClass: "calibre"
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/Text/Section0005#CHAPTER_III"
    }
  }, [_vm._v("CHAPTER III")]), _c('br', {
    staticClass: "calibre"
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/Text/Section0006#CHAPTER_IV"
    }
  }, [_vm._v("CHAPTER IV")]), _c('br', {
    staticClass: "calibre"
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/Text/Section0007#CHAPTER_V"
    }
  }, [_vm._v("CHAPTER V")]), _c('br', {
    staticClass: "calibre"
  }), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/Text/Section0008#CHAPTER_VI",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER VI")]), _c('br', {
    staticClass: "calibre"
  }), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/Text/Section0009#CHAPTER_VII",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER VII")]), _c('br', {
    staticClass: "calibre"
  }), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/Text/Section0010#CHAPTER_VIII",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER VIII")]), _c('br', {
    staticClass: "calibre"
  }), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/Text/Section0011#CHAPTER_IX",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER IX")]), _c('br', {
    staticClass: "calibre"
  }), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/Text/Section0012#CHAPTER_X",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER X")]), _c('br', {
    staticClass: "calibre"
  }), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/Text/Section0013#CHAPTER_XI",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER XI")]), _c('br', {
    staticClass: "calibre"
  }), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/Text/Section0014#CHAPTER_XII",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER XII")]), _c('br', {
    staticClass: "calibre"
  }), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/Text/Section0015#CHAPTER_XIII",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER XIII")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('a', {
    attrs: {
      "id": "pgepubid00001",
      "title": "[1]"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "figcenter"
  }, [_c('img', {
    staticClass: "calibre2",
    attrs: {
      "alt": "",
      "src": "Images/img0010.jpg"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a637da12","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/Section0002.vue
// module id = 60
// module chunks = 0